export default __webpack_public_path__ + "static/media/header.6106ff07.png";